import { DateFormatter } from '../date-formatter.class';
import { DatesGroup } from './dates-group.interface';

/**
 * It takes an array of dates and returns an array of objects, each object
 * containing a month and an array of dates that belong to that month
 * @param {Date[]} dates - Date[] - an array of dates to be grouped
 * @returns An array of objects with the month and the dates that are in that
 * month.
 */
export const groupDatesByMonth = (
  dates: Date[],
  locale?: string,
  format?: string
): DatesGroup[] => {
  const groupsByMonth: DatesGroup[] = [];
  const months = Array.from(
    new Set(
      dates.map(
        (date) =>
          new DateFormatter(locale).getMonthString(date, format) as string
      )
    )
  );

  months.forEach((month) => {
    const group: DatesGroup = {
      label: month,
      dates: dates.filter((date) => {
        const monthDate = new DateFormatter(locale).getMonthString(
          date,
          format
        ) as string;
        return monthDate === month;
      }),
    };

    groupsByMonth.push(group);
  });

  return groupsByMonth;
};
